import { render, staticRenderFns } from "./EventBrief.vue?vue&type=template&id=d67e4028&scoped=true&"
import script from "./EventBrief.vue?vue&type=script&lang=js&"
export * from "./EventBrief.vue?vue&type=script&lang=js&"
import style0 from "./EventBrief.vue?vue&type=style&index=0&id=d67e4028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67e4028",
  null
  
)

export default component.exports